<template>
  <component
    :is="isClickable ? BaseButton : getActionLinkComponent(content.target)"
    class="w-full flex items-center gap-2 px-4 py-3 subtitle-4 between"
    :class="{ 'cursor-pointer bg-transparent p-0 text-left': !isClickable && isActionLinkOnly(content.target) }"
    v-bind="isClickable ? {} : getActionLinkAttrs(content.target)"
    rel="noopener nofollow"
    @click="handleL1Click"
  >
    <div class="flex items-center gap-x-1">
      <vf-icon
        v-if="menuIcons[content.menuIcon?.icon!]"
        class="pointer-events-none"
        height="26"
        :src="menuIcons[content.menuIcon?.icon!]"
        width="26"
      />
      {{ content.title }}
    </div>
    <vf-icon v-if="isClickable" name="chevron" />
  </component>
</template>

<script lang="ts" setup>
import type { MegaMenuL1Context } from '#content/contexts/megamenu'
import type { MenuItem } from '#types/components/cms/mega-menu'
import type { RecursivePartial } from '#types/utils'
import { BaseButton } from '#components'
import { MegaMenuL1ContextKey } from '#content/contexts/megamenu'

const { content } = defineProps<{ content: MenuItem }>()

const { menuIcons } = useAppConfig().assets
const { $gtm } = useNuxtApp()
const {
  canRenderActionLink,
  getActionLinkAttrs,
  getActionLinkComponent,
  getActionLinkHandler,
  isActionLinkOnly,
} = useCmsActionLink('header:mega-menu')

const { activeL1, expandedL2 } = inject(MegaMenuL1ContextKey, {} as MegaMenuL1Context)

const isClickable = computed(() => content.columns?.length || content.visualSelectors)

const getClickEventLabel = (...args: RecursivePartial<MenuItem>[]) =>
  args.map((mi) => cleanMegaMenuLabel(mi.title || mi.target?.delocalizedTracking || mi.delocalizedTracking || mi.name || '')).join(' | ')

const handleL1Click = () => {
  const eventLabel = formatMegaMenuLevelLabel(getMegaMenuItemLabel(content), 1)

  if (!isClickable.value && canRenderActionLink(content.target)) {
    if (isActionLinkOnly(content.target)) getActionLinkHandler(content.target, getMegaMenuItemLabel(content))?.()
    return $gtm.push('topNav.onClickTopNavLink', eventLabel)
  }

  if (activeL1?.value) {
    activeL1.value = content
  }

  if (expandedL2?.value) {
    expandedL2.value = []
  }

  $gtm.push('topNav.onClickMobileMenuSection', getClickEventLabel(content))
}
</script>
